import React, { useEffect, useState } from "react";
import {
	Grid,
	Table,
	TableContainer,
	TableBody,
	TableRow,
	TableCell,
} from "@mui/material";
import useStore from "../store/store";
import style from "../utils/style";
import constants from "../utils/constants";
import utils from "../utils/utils";
import transactionService from "../services/transaction";
import PageHeading from "./PageHeading";
import { ArrowUp, ArrowDown } from "./Arrows";
import Confirm from "./Confirm";
import moment from "moment";

function TransactionDetails({ reload, toggleDrawer }) {
	let [data, setData] = useState([]);
	const [isOpen, setIsOpen] = useState(false);
	let {
		token,
		setErrorMessage,
		setIsLoading,
		setSuccessMessage,
		currObj,
		setCurrObj,
	} = useStore((state) => state);

	useEffect(() => {
		if (currObj) getData();
	}, [currObj]);

	const getData = () => {
		let data = {
			_id: currObj._id,
			fromId: currObj.fromId,
			toId: currObj.toId,
			stockId: currObj.stockId || "",
		};
		transactionService.getById(token, data).then((r) => {
			if (r.error) {
				setErrorMessage(r.error);
				setIsLoading(false);
				return;
			}
			if (r.data) {
				setData(r.data[0]);
			}
		});
	};

	const deleteRecord = () => {
		transactionService
			.delete(token, currObj?._id)
			.then((res) => {
				if (res.error) {
					setErrorMessage(res.error);
					setIsLoading(false);
					return;
				}
				setSuccessMessage("Transaction deleted successfully.");
				setCurrObj(null);
				reload();
				setIsOpen(false);
				toggleDrawer();
			})
			.catch((err) => {
				setErrorMessage(err.message);
			});
	};

	return (
		<>
			<Confirm
				open={isOpen}
				onNo={() => {
					setIsOpen(false);
				}}
				onYes={() => {
					setIsOpen(false);
					deleteRecord();
				}}
				title="Are you sure?"
				body="This transaction will be deleted."
			/>

			<Grid container sx={style.container}>
				<Grid item xs={12} md={12}>
					<PageHeading text="Details" />
				</Grid>

				{data && (
					<Grid item xs={12} sx={{ color: constants.PRIMARY }}>
						<TableContainer>
							<Table>
								<TableBody>
									{data.fromAccount && (
										<TableRow
											sx={{
												"&:last-child td, &:last-child th":
													{
														border: 0,
													},
											}}
										>
											<TableCell align="right">
												<ArrowUp />
											</TableCell>
											<TableCell
												sx={style.accDetailText}
												component="th"
												scope="row"
												align="left"
											>
												{data.fromAccount.title} <br />
												<span
													style={{ fontSize: "12px" }}
												>
													<a
														href={`tel:${data.fromAccount.phone}`}
													>
														{data.fromAccount.phone}
													</a>
												</span>
											</TableCell>
										</TableRow>
									)}
									{data.toAccount && (
										<TableRow
											sx={{
												"&:last-child td, &:last-child th":
													{
														border: 0,
													},
											}}
										>
											<TableCell align="right">
												<ArrowDown />
											</TableCell>
											<TableCell
												sx={style.accDetailText}
												component="th"
												scope="row"
												align="left"
											>
												{data.toAccount.title}
												<br />
												<span
													style={{ fontSize: "12px" }}
												>
													<a
														href={`tel:${data.toAccount.phone}`}
													>
														{data.toAccount.phone}
													</a>
												</span>
											</TableCell>
										</TableRow>
									)}
									{data.amount && (
										<TableRow
											sx={{
												"&:last-child td, &:last-child th":
													{
														border: 0,
													},
											}}
										>
											<TableCell align="right">
												<ion-icon
													name="wallet-outline"
													style={style.accDetailIcons}
												></ion-icon>
											</TableCell>
											<TableCell
												sx={style.accDetailText}
												component="th"
												scope="row"
												align="left"
											>
												{utils.formatToCurrency(
													data?.amount,
													"Rs. "
												)}
											</TableCell>
										</TableRow>
									)}
									{data.note && (
										<TableRow
											sx={{
												"&:last-child td, &:last-child th":
													{
														border: 0,
													},
											}}
										>
											<TableCell align="right">
												<ion-icon
													name="pencil-outline"
													style={style.accDetailIcons}
												></ion-icon>
											</TableCell>
											<TableCell
												sx={style.accDetailText}
												component="th"
												scope="row"
												align="left"
											>
												{data.note}
											</TableCell>
										</TableRow>
									)}
									{data.stockId && (
										<TableRow
											sx={{
												"&:last-child td, &:last-child th":
													{
														border: 0,
													},
											}}
										>
											<TableCell align="right">
												<ion-icon
													name="grid-outline"
													style={style.accDetailIcons}
												></ion-icon>
											</TableCell>
											<TableCell
												sx={style.accDetailText}
												component="th"
												scope="row"
												align="left"
											>
												{data.stock.title} |{" "}
												{utils.formatToNumber(
													data.quantity
												)}{" "}
											</TableCell>
										</TableRow>
									)}
									{data._id && (
										<TableRow
											sx={{
												"&:last-child td, &:last-child th":
													{
														border: 0,
													},
												cursor: "pointer",
											}}
											onClick={() => setIsOpen(true)}
										>
											<TableCell align="right">
												<ion-icon
													name="trash-outline"
													style={{
														...style.accDetailIcons,
														color: "red",
													}}
												></ion-icon>
											</TableCell>
											<TableCell
												sx={{
													...style.accDetailText,
													color: "red",
												}}
												component="th"
												scope="row"
												align="left"
											>
												Delete
											</TableCell>
										</TableRow>
									)}
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
										}}
									>
										<TableCell align="right">
											<ion-icon
												name="time-outline"
												style={style.accDetailIcons}
											></ion-icon>
										</TableCell>
										<TableCell
											sx={style.accDetailText}
											component="th"
											scope="row"
											align="left"
										>
											{moment(data.createdAt).format(
												"DD MMMM YYYY"
											)}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</Grid>
				)}
			</Grid>
		</>
	);
}

export default TransactionDetails;
